import isAgendaItemNotHeader from './isAgendaItemNotHeader';
import { AgendaItem } from 'mini-agenda';
import { convertEpochTimeToDisplayDate } from 'mini-calendar-events-store';
import { isSameDay } from 'owa-datetime';

/**
 * Checks if agenda items are of different days
 * @param item1 First agenda item to check
 * @param item2 Second agenda item to check
 */
function areAgendaItemsOfDifferentDays(item1: AgendaItem, item2: AgendaItem) {
    return !isSameDay(
        item1 && convertEpochTimeToDisplayDate(item1.timestamp),
        item2 && convertEpochTimeToDisplayDate(item2.timestamp)
    );
}

/**
 * Checks if header can be inserted between two agenda items
 * @param agendaItem1 First agenda item
 * @param agendaItem2 Second agenda item
 */
export default function shouldAddHeaderBetweenAgendaItems(
    agendaItem1: AgendaItem,
    agendaItem2: AgendaItem
): boolean {
    return (
        !!agendaItem1 &&
        !!agendaItem2 &&
        isAgendaItemNotHeader(agendaItem1) &&
        isAgendaItemNotHeader(agendaItem2) &&
        areAgendaItemsOfDifferentDays(agendaItem1, agendaItem2)
    );
}
